import {
  IconNavigationStartpage,
  IconNavigationContacts,
  IconNavigationMessenger,
  IconComplexPremiumDiamond,
  IconComplexProbusiness,
  IconNavigationProjobs,
  IconProfileEducation,
  IconNavigationJobs,
  IconNavigationEvents,
  IconNavigationNews,
  IconNavigationCommunities,
  IconNavigationCompanies,
  IconNavigationBusinessServices,
  IconNavigationOtherServices,
  IconMiscButterflyHex,
} from '@xingternal/malt-icon';
import {
  IconCampus,
  IconCampusFilled,
  IconCompanies,
  IconCompaniesFilled,
  IconContacts,
  IconContactsFilled,
  IconEvents,
  IconEventsFilled,
  IconGroups,
  IconGroupsFilled,
  IconHome,
  IconHomeFilled,
  IconJobs,
  IconJobsFilled,
  IconMessages,
  IconMessagesFilled,
  IconNews,
  IconNewsFilled,
  IconOtherServices,
  IconOtherServicesFilled,
  IconSettings,
  IconSettingsFilled,
} from '@xingternal/designkit';
import BurgerMenuIcon from '@xingternal/xing-view/Navigation/HorizontalNavigation/BurgerMenuIcon';

const _premium = {
  proBusiness: {
    key: 'proBusiness',
    iconOdl: IconComplexProbusiness,
    title: 'VERTICAL_NAVIGATION_PROBUSINESS',
    href: '/probusiness',
    notificationKey: 'probusinessNotifications',
  },
  premiumUpsell: {
    key: 'premiumUpsell',
    iconOdl: IconComplexPremiumDiamond,
    title: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS',
    subTitle: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SUBLINE',
    href: '/premium?sc_o=mxb_pre;reagent=uplt_76',
  },
  premium: {
    key: 'premium',
    iconOdl: IconComplexPremiumDiamond,
    title: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS',
    href: '/premium?sc_o=mxb_pre',
    notificationKey: 'premiumPerksNew',
  },
  proJobs: {
    key: 'proJobs',
    iconOdl: IconNavigationProjobs,
    title: 'VERTICAL_NAVIGATION_MYPROJOBS',
    href: '/projobs/dashboard?sc_o=ojm-467_navigation',
  },
};

const _personalLinks = {
  premiumUpsellPersonal: {
    key: 'premiumUpsellPersonal',
    iconOdl: IconComplexPremiumDiamond,
    activeIconOdl: IconMiscButterflyHex,
    href: '/upsell/premium?reagent=uplt_284',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP',
    highlighted: true,
  },
  proJobsPersonal: {
    key: 'proJobsPersonal',
    iconOdl: IconComplexPremiumDiamond,
    activeIconOdl: IconMiscButterflyHex,
    href: '/upsell/projobs?reagent=uplt_283',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP',
    highlighted: true,
  },
  proBusinessMemberPersonal: {
    key: 'proBusinessMemberPersonal',
    iconOdl: IconComplexPremiumDiamond,
    activeIconOdl: IconMiscButterflyHex,
    href: '/upsell/pro_business_offers?reagent=uplt_500',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP',
    highlighted: true,
  },
  benefitsPersonal: {
    key: 'benefitsPersonal',
    iconOdl: IconComplexPremiumDiamond,
    activeIconOdl: IconMiscButterflyHex,
    href: '/upsell/benefits_plus_offers?reagent=uplt_628',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_BENEFITS_PLUS_MEMBERSHIP',
    highlighted: true,
  },
  proJobsMemberPersonal: {
    key: 'proJobsMemberPersonal',
    href: '/projobs/start?sc_o=navi16',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS',
  },
  coachProfilePersonal: {
    key: 'coachProfilePersonal',
    href:
      'https://coaches.xing.com/coaches/meinprofil?sc_o=DA_352_personal_menu_link',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE',
  },
  xtmPersonal: {
    key: 'xtmPersonal',
    href: '/xtm',
    title: 'VERTICAL_NAVIGATION_HEADER_XTM',
  },
  seatManagerAdminPersonal: {
    key: 'seatManagerAdminPersonal',
    href: '/seat-manager',
    title: 'VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN',
  },
  jobsPosterPersonal: {
    key: 'jobsPosterPersonal',
    href: '/jobs/manage?sc_o=xjm_navigation_dropdown_manage_job_ads',
    title: 'VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS',
  },
  brandPagePersonal: {
    key: 'brandPagePersonal',
    href: '/xbp/manage/pages',
    title: 'XBP_NAVIGATION_ENTRY_LINK',
    flag: 'PROMO',
  },
  admasterUserPersonal: {
    key: 'admasterUserPersonal',
    href: '/xas/ads?sc_o=ad_542',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS',
  },
  brandManagerEditor: {
    key: 'brandManagerEditor',
    href: '/brandmanager',
    title: 'VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR',
  },
};

const _FooterLinks = {
  helpFooter: {
    key: 'help',
    title: 'VERTICAL_NAVIGATION_FOOTER_HELP',
    href: {
      de: 'https://faq.xing.com/de',
      en: 'https://faq.xing.com/en',
    },
  },
  aboutFooter: {
    key: 'about',
    title: 'VERTICAL_NAVIGATION_FOOTER_XING_AG',
    href: {
      de: 'https://corporate.xing.com/de/unternehmen/',
      en: 'https://corporate.xing.com/en/about-xing/',
    },
  },
  careersFooter: {
    key: 'careers',
    title: 'VERTICAL_NAVIGATION_FOOTER_JOBS',
    href: {
      de: 'https://corporate.xing.com/de/karriere/',
      en: 'https://corporate.xing.com/en/career/',
    },
  },
  investorRelationsFooter: {
    key: 'investorRelations',
    title: 'VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS',
    href: {
      de: 'https://corporate.xing.com/de/investor-relations/',
      en: 'https://corporate.xing.com/en/investor-relations/',
    },
  },
  pressFooter: {
    key: 'press',
    title: 'VERTICAL_NAVIGATION_FOOTER_PRESS',
    href: {
      de: 'https://corporate.xing.com/de/newsroom/',
      en: 'https://corporate.xing.com/en/newsroom/',
    },
  },
  xingCommunityFooter: {
    key: 'xingCommunity',
    title: 'VERTICAL_NAVIGATION_FOOTER_COMMUNITY',
    href: 'https://www.xing.com/communities/groups/xing-community-1000150',
  },
  newWorkExperienceFooter: {
    key: 'newWorkExperience',
    title: 'VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE',
    href: 'https://nwx.xing.com/',
    languages: ['Deutsch'],
  },
  blogFooter: {
    key: 'blog',
    title: 'VERTICAL_NAVIGATION_FOOTER_BLOG',
    href: 'https://blog.xing.com/de/startseite/',
  },
  devBlogFooter: {
    key: 'devBlog',
    title: 'VERTICAL_NAVIGATION_FOOTER_DEVBLOG',
    href: 'https://tech.xing.com/',
  },
  developersFooter: {
    key: 'developers',
    title: 'VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL',
    href: 'https://dev.xing.com/',
  },
  peopleDirectoryFooter: {
    key: 'peopleDirectory',
    title: 'VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY',
    href: 'https://www.xing.com/people/',
  },
};

const _menuLinks = {
  home: {
    key: 'home',
    iconOdl: IconNavigationStartpage,
    iconXdl: IconHome,
    activeIconXdl: IconHomeFilled,
    title: 'VERTICAL_NAVIGATION_STARTPAGE',
    href: '/',
    notificationKey: 'activities',
  },
  contacts: {
    key: 'contacts',
    iconOdl: IconNavigationContacts,
    iconXdl: IconContacts,
    activeIconXdl: IconContactsFilled,
    title: 'VERTICAL_NAVIGATION_CONTACTS',
    href: '/contacts',
    notificationKey: 'contactRequests',
  },
  messages: {
    key: 'messages',
    iconOdl: IconNavigationMessenger,
    iconXdl: IconMessages,
    activeIconXdl: IconMessagesFilled,
    title: 'VERTICAL_NAVIGATION_MESSAGES',
    href: '/messenger',
    notificationKey: 'unreadChats',
  },
  campus: {
    key: 'campus',
    iconOdl: IconProfileEducation,
    iconXdl: IconCampus,
    activeIconXdl: IconCampusFilled,
    title: 'VERTICAL_NAVIGATION_CAMPUS',
    href: '/campus',
  },
  menu: {
    key: 'more',
    iconXdl: BurgerMenuIcon,
    title: 'VERTICAL_NAVIGATION_MORE',
  },
  jobs: {
    key: 'jobs',
    iconOdl: IconNavigationJobs,
    iconXdl: IconJobs,
    activeIconXdl: IconJobsFilled,
    title: 'VERTICAL_NAVIGATION_FOOTER_JOB_MARKET',
    href: '/jobs',
    notificationKey: 'jobs',
  },
  events: {
    key: 'events',
    iconOdl: IconNavigationEvents,
    iconXdl: IconEvents,
    activeIconXdl: IconEventsFilled,
    title: 'VERTICAL_NAVIGATION_EVENTS',
    href: '/events?sc_o=mxb_e_da207',
    notificationKey: 'events',
  },
  content: {
    key: 'content',
    iconOdl: IconNavigationNews,
    iconXdl: IconNews,
    activeIconXdl: IconNewsFilled,
    title: 'VERTICAL_NAVIGATION_CONTENT_PAGES',
    href: '/news?sc_o=b7916_mxb',
    notificationKey: 'news',
  },
  groups: {
    key: 'groups',
    iconOdl: IconNavigationCommunities,
    iconXdl: IconGroups,
    activeIconXdl: IconGroupsFilled,
    title: 'VERTICAL_NAVIGATION_COMMUNITIES',
    href: '/communities',
    notificationKey: 'groupsWeb',
  },
  companies: {
    key: 'companies',
    iconOdl: IconNavigationCompanies,
    iconXdl: IconCompanies,
    activeIconXdl: IconCompaniesFilled,
    title: 'VERTICAL_NAVIGATION_COMPANIES',
    href: '/companies',
  },
  business: {
    key: 'business',
    iconOdl: IconNavigationBusinessServices,
    title: 'VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS',
    href: '/app/user?op=xing_services.business',
  },
  services: {
    key: 'services',
    iconOdl: IconNavigationOtherServices,
    iconXdl: IconOtherServices,
    activeIconXdl: IconOtherServicesFilled,
    title: 'VERTICAL_NAVIGATION_OTHER_SERVICES',
    href: '/app/user?op=xing_services.other',
  },
  helpPersonal: {
    key: 'helpPersonal',
    href: '/help',
    title: 'VERTICAL_NAVIGATION_HEADER_HELP',
  },
  settingsPersonal: {
    key: 'settingsPersonal',
    iconXdl: IconSettings,
    activeIconXdl: IconSettingsFilled,
    href: '/settings',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS',
  },
  invoicesPersonal: {
    key: 'invoicesPersonal',
    href: '/payments/settings',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES',
  },
  logoutPersonal: {
    key: 'logoutPersonal',
    href: '/login/logout',
    title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT',
  },
};

const _appLinks = {
  apps: {
    key: 'apps',
    title: 'VERTICAL_NAVIGATION_FOOTER_APP_GALLERY',
    href: {
      de: 'https://mobile.xing.com/de/',
      en: 'https://mobile.xing.com/en/',
    },
  },
  loginWithXing: {
    key: 'loginWithXing',
    title: 'VERTICAL_NAVIGATION_FOOTER_LOGINWXING',
    href: 'https://dev.xing.com/plugins/login_with',
  },
  shareButton: {
    key: 'shareButton',
    title: 'VERTICAL_NAVIGATION_FOOTER_XING_SHARE',
    href: 'https://www.xing.com/app/share?op=button_builder',
  },
  downloads: {
    key: 'downloads',
    title: 'VERTICAL_NAVIGATION_FOOTER_DOWNLOAD',
    href: 'https://www.xing.com/app/user?op=downloads',
  },
};

const _legalLinks = {
  imprint: {
    key: 'imprint',
    title: 'VERTICAL_NAVIGATION_FOOTER_IMPRINT',
    href: 'https://www.xing.com/imprint',
  },
  tAndC: {
    key: 'tAndC',
    title: 'VERTICAL_NAVIGATION_FOOTER_TANDC',
    href: 'https://www.xing.com/terms',
  },
  privacyAtXing: {
    key: 'privacyAtXing',
    title: 'VERTICAL_NAVIGATION_FOOTER_PRIVACY',
    href: {
      de: 'https://privacy.xing.com/de',
      en: 'https://privacy.xing.com/en',
    },
  },
  privacyPolicy: {
    key: 'privacyPolicy',
    title: 'VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY',
    href: {
      de: 'https://privacy.xing.com/de/datenschutzerklaerung',
      en: 'https://privacy.xing.com/en/privacy-policy',
    },
  },
};

const _offerLinks = {
  premiumOffer: {
    key: 'premiumOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP',
    href: 'https://www.xing.com/upsell/premium_offers?reagent=uplt_98',
  },
  proJobsOffer: {
    key: 'proJobsOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP',
    href: 'https://www.xing.com/upsell/projobs?reagent=uplt_205',
  },
  proBusinessOffer: {
    key: 'proBusinessOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP',
    href: 'https://www.xing.com/upsell/pro_business_offers?reagent=uplt_501',
  },
  benefitsPlusOffer: {
    key: 'benefitsPlusOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_BENEFITS_PLUS_MEMBERSHIP',
    href: 'https://www.xing.com/upsell/benefits_plus_offers?reagent=uplt_627',
  },
  executivesOffer: {
    key: 'executivesOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_EXECUTIVES_MEMBERSHIP',
    href: 'https://executive.xing.com/',
  },
  eRecruitingOffer: {
    key: 'eRecruitingOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER',
    href: {
      de: 'https://recruiting.xing.com/de/',
      en: 'https://recruiting.xing.com/en/',
    },
  },
  advertisementOffer: {
    key: 'advertisementOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_XAS',
    href: 'https://www.xing.com/xas?sc_o=SI-4110_footer_link_admanager',
  },
  halloFreelancerOffer: {
    key: 'halloFreelancerOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER',
    href: 'https://www.hallofreelancer.com/',
    languages: ['Deutsch'],
  },
  marketingSolutionsOffer: {
    key: 'marketingSolutionsOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_ADVERTISE',
    href: {
      de: 'https://werben.xing.com',
      en: 'https://advertising.xing.com',
    },
  },
  mobileOffer: {
    key: 'mobileOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_MOBILE',
    href: 'https://mobile.xing.com/en/',
  },
  premiumOfferPartners: {
    key: 'premiumOfferPartners',
    title: 'VERTICAL_NAVIGATION_FOOTER_TOP_DEALS',
    href: 'https://www.xing.com/premium/partners?sc_o=bo_4',
  },
  xingEventsOffer: {
    key: 'xingEventsOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_AMIANDO',
    href: 'https://www.xing-events.com/',
  },
  salaryCheckOffer: {
    key: 'salaryCheckOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH',
    href: 'https://www.xing.com/salary/',
  },
  salaryCheckMatchOffer: {
    key: 'salaryCheckMatchOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH',
    href: 'https://www.xing.com/salary/match',
  },
  curriculumVitaeEditor: {
    // where is this currently
    key: 'curriculumVitaeEditor',
    title: 'VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF',
    href: 'https://lebenslauf.com/',
  },
  coverLetterEditor: {
    // where is this currently
    key: 'coverLetterEditor',
    title: 'VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN',
    href: 'https://anschreiben.com/',
  },
  jobApplicationTips: {
    // where is this currently
    key: 'jobApplicationTips',
    title: 'VERTICAL_NAVIGATION_FOOTER_BEWERBUNG',
    href: 'https://bewerbung.com/',
  },
  kununuOffer: {
    // where is this currently
    key: 'kununuOffer',
    title: 'VERTICAL_NAVIGATION_FOOTER_KUNUNU',
    href: 'https://www.kununu.com/',
  },
};

// links not present in _menuLinks
const _siteSections = {
  jobsFooter: {
    key: 'jobsFooter',
    title: 'VERTICAL_NAVIGATION_FOOTER_JOB_MARKET',
    href: 'https://www.xing.com/jobs',
  },
  eventsFooter: {
    key: 'eventsFooter',
    title: 'VERTICAL_NAVIGATION_FOOTER_EVENTS',
    href: 'https://www.xing.com/events',
  },
  newsFooter: {
    key: 'newsFooter',
    title: 'VERTICAL_NAVIGATION_FOOTER_XING_NEWS',
    href: 'https://www.xing.com/news',
  },
  groupsFooter: {
    key: 'groupsFooter',
    title: 'VERTICAL_NAVIGATION_FOOTER_GROUPS',
    href: 'https://www.xing.com/communities',
  },
  companiesFooter: {
    key: 'companiesFooter',
    title: 'VERTICAL_NAVIGATION_FOOTER_COMPANIES',
    href: 'https://www.xing.com/companies',
  },
  campusFooter: {
    key: 'campusFooter',
    title: 'VERTICAL_NAVIGATION_FOOTER_CAMPUS',
    href: 'https://www.xing.com/campus',
  },
  coachesFooter: {
    key: 'coachesFooter',
    title: 'VERTICAL_NAVIGATION_FOOTER_COACHES',
    href: 'https://coaches.xing.com/',
  },
};

const navigationItems = {
  ..._menuLinks,
  ..._premium,
  ..._personalLinks,
  ..._FooterLinks,
  ..._appLinks,
  ..._legalLinks,
  ..._offerLinks,
  ..._siteSections,
};

export default navigationItems;
